/* eslint-disable @typescript-eslint/no-explicit-any */
import { DesignedIcon, Rule } from "@with-nx/simple-ui/atoms";
import { createRef, useCallback, useEffect, useState } from "react";
import { Box } from "simple-effing-primitive-layout";

import { UploadedFile, useFile } from "./useFile";
import { handle as HANDLE } from "./utils";

interface AreaProps {
  accept?: string;
  height?: number;
  inputRef: React.RefObject<HTMLInputElement>;
  uploading?: boolean;
  choose: (file: File | null) => void;
  click: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const AwsArea = ({
  accept = ".png, .jpg, .jpeg, .mp3, .mp4",
  height = 40,
  inputRef,
  uploading,
  choose,
  click,
}: AreaProps) => {
  return (
    <Box bottom={24}>
      <input
        type="file"
        ref={inputRef}
        className="invisible absolute"
        disabled={uploading}
        onChange={(e) =>
          choose(e.currentTarget.files ? e.currentTarget.files.item(0) : null)
        }
        accept={accept}
      />
      <button
        onClick={(e) => {
          e.preventDefault();
          click(e);
        }}
        className="d:block w:100%"
      >
        <Box
          parse={`h:${height} w:100% br:5 d:flex a:center j:center`}
          color="rgba(255,255,255,0.025)"
          border={`1px dashed rgba(255, 255, 255, 0.1`}
        >
          {uploading ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16px"
              height="16px"
              viewBox="0 0 16 16"
              preserveAspectRatio="xMidYMid"
            >
              <circle
                cx="8"
                cy="8"
                fill="none"
                stroke="#6F6F6F"
                strokeWidth="2"
                r="6"
                strokeDasharray="28.274333882308138 11.42477796076938"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  repeatCount="indefinite"
                  dur="1s"
                  values="0 8 8;360 8 8"
                  keyTimes="0;1"
                ></animateTransform>
              </circle>
            </svg>
          ) : (
            <Rule color="#6F6F6F" rule="lt">
              Drop Files Here | {accept.toUpperCase()}
            </Rule>
          )}
        </Box>
      </button>
    </Box>
  );
};

export default AwsArea;
